/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import * as url from '@bingads-webui/url-util';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/upgraded-url');
var validate = function (trackingTemplate) {
  var errorList = [];
  if (!url.hasScheme(trackingTemplate) && !_.find(['{lpurl}', '{unescapedlpurl}'], function (tag) {
    return trackingTemplate.indexOf(tag) === 0;
  })) {
    errorList = _.union(errorList, [i18n.get('Error_Campaign_API_InvalidUrlScheme')]);
  }
  if (trackingTemplate.trim().length > 2048) {
    errorList = _.union(errorList, [i18n.get('Error_Campaign_API_TrackingTemplateTooLong')]);
  }
  return errorList;
};
var trackingTemplate = function (options) {
  this.editMode = ko.observable(options.editMode);
  this.maxLength = 2048;
  this.trackingTemplate = ko.observable(options.trackingTemplate);
  this.trackingTemplateErrors = ko.observableArray();
  this.finalUrlSuffix = ko.observable(options.finalUrlSuffix);
  this.errorMessages = ko.observableArray(options.errorMessages);
  this.errors = ko.computed(function () {
    var trackingTemplate = this.trackingTemplate(), errorList = [];
    if (trackingTemplate) {
      errorList = validate(trackingTemplate);
    }
    this.errorMessages(errorList);
    return errorList.length;
  }, this);
  this.showNone = ko.computed(function () {
    return !this.editMode() && !this.trackingTemplate();
  }, this);
  this.getTrackingTemplate = ko.computed(function () {
    return {
      trackingTemplate: this.trackingTemplate(),
      errors: this.errors()
    };
  }, this);
  this.templateExampleEnabled = ko.observable(options.templateExampleEnabled);
};
export default trackingTemplate;

